module.exports = __webpack_public_path__ + "img/Palette-Puroak-FR.asset.470aa86d.svg";